var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page-content"},[_c('img',{attrs:{"src":require("@/assets/images/warning.png"),"alt":""}}),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.$route.query.err||'绑定失败'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }